import { config, LEAD_API_KEY } from "@/shared/utils/config"
import ky from "ky"

export type CreateCheckoutSessionResponse = {
  client_secret: string
}

export const checkoutAPI = ky.create({
  prefixUrl: `https://checkout.${config.API_DOMAIN}/${config.PRODUCT}/v2`,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    "x-api-key": LEAD_API_KEY,
  },
  timeout: 30000,
})

export type StripeCheckoutOptions = {
  stripe_promotion_code_id?: string | null
  discount_type?: "RAF" | "PROMO" | null
}

/**
 * URL: `/create-payment-intent`
 *
 * Creates a Payment Intent with client secret for self-hosted checkout.
 */
export async function stripeCheckout(
  quoteId: string,
  petIndexes: number[],
  locale?: string,
  options: StripeCheckoutOptions = {}
): Promise<CreateCheckoutSessionResponse> {
  const { stripe_promotion_code_id, discount_type } = options
  return await checkoutAPI
    .post("create-payment-intent?request_from=LIABILITY", {
      json: {
        type: "checkout.create",
        quote_id: quoteId,
        locale,
        metadata: {
          pets: petIndexes,
        },
        ...(stripe_promotion_code_id ? { stripe_promotion_code_id } : {}),
        ...(discount_type ? { discount_type } : {}),
      },
    })
    .json<CreateCheckoutSessionResponse>()
}

/**
 * URL: `/expire-checkout-session`
 */
export async function expireCheckoutSession(quoteId: string) {
  return await checkoutAPI
    .post("expire-checkout-session", {
      json: {
        quote_id: quoteId,
      },
    })
    .then((response) => response.json())
}
